import React from "react"
import styled from "@emotion/styled"

const Outer = styled.div`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  width: 100%;
  padding: 96px 0;
  align-items: center;
  background: ${props =>
    props.backgroundColorOverride
      ? props.backgroundColorOverride
      : "transparent"};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2 / 3;
  align-items: center;
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    display: grid;
    gap: 80px;
    grid-auto-flow: dense;
    grid-template-columns: 1fr 1fr;
  }
`
const MediaFeatureImage = styled.div`
  width: 100%;
  margin-top: auto;
  margin-bottom: auto;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin-bottom: 16px;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-column: ${props => (props.reverse ? "1" : "2")};
  }
`
const MediaFeatureText = styled.div`
  width: 100%;
  ul {
    list-style: none;
    margin: 0;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-column: ${props => (props.reverse ? "2" : "1")};
  }
`
const Image = styled.img`
  width: 100%;
`

export default function MediaFeature({
  backgroundColorOverride,
  reverse,
  src,
  alt,
  children,
}) {
  return (
    <Outer backgroundColorOverride={backgroundColorOverride}>
      <Inner reverse={reverse}>
        <MediaFeatureImage reverse={reverse}>
          <Image src={src} alt={alt} />
        </MediaFeatureImage>
        <MediaFeatureText reverse={reverse}>{children}</MediaFeatureText>
      </Inner>
    </Outer>
  )
}
